import ActionFloatingButton from "@/components/ActionFloatingButton"
import GoToAdmin from "@/components/GoToAdmin"
import GoToProfile from "@/components/GoToProfile"

export default {
	components: {
		ActionFloatingButton,
		GoToAdmin,
		GoToProfile,
	},
}